<app-select
  [label]="'SELECT_BY_ENDPOINT.PAYMENT_METHOD.LABEL' | translate"
  [placeholder]="'SELECT_BY_ENDPOINT.PAYMENT_METHOD.PLACEHOLDER' | translate"
  [items]="paymentMethodsOptions"
  [control]="control()"
  (searchChange)="getPaymentMethods($event)"
  filteredByEndpoint
  [totalPages]="totalPages"
  (paginationChange)="handlePaginationChange()"
  [paginationCount]="page"
></app-select>
